import React, { useState } from 'react';
import { CcLoader } from '@utp/components-react';
import { ToggleButton } from '../../procedures/components';
import {
  DropDownContainer,
  DropDownTitle,
  NumberOfPayItemsCircle
} from './styled';
import { DivisionLine } from '../../courses/modules/myCourses/components/MyCoursesCollapsibles/styled';

interface DropdownPaymentsProps {
  title: string;
  itemsNumber: number;
  childContent: any;
  itStartsOpened?: boolean;
  isLoading: boolean;
}
const DropdownPayments = ({
  title,
  itemsNumber,
  childContent,
  itStartsOpened,
  isLoading
}: DropdownPaymentsProps) => {
  const [toggleOpen, setToggleOpen] = useState(itStartsOpened || false);

  return (
    <DropDownContainer>
      <DivisionLine backgroundColor="#7A959F" applyMediaQuery />
      <div className="main">
        <DropDownTitle>
          {title}
          {isLoading ? (
            <CcLoader size={20} color="black" />
          ) : (
            <NumberOfPayItemsCircle>{itemsNumber}</NumberOfPayItemsCircle>
          )}
        </DropDownTitle>
        <ToggleButton
          itStartsOpened={itStartsOpened}
          onClick={() => {
            setToggleOpen(!toggleOpen);
          }}
        />
      </div>

      {toggleOpen && <div>{childContent}</div>}
    </DropDownContainer>
  );
};

export { DropdownPayments };
